/* eslint import/prefer-default-export: 0 */

export const activityTypes = [
    'Regular Run',
    'Easy Run',
    'Regular Run AYF',
    'Long Run',
    'Pseudo Long Run',
    'Tempo',
    'Intervals',
    'Fartlek',
    'Hills',
    'Time Trial',
    'Cross Train',
    'Race',
];

export const dayOffTypes = [
    'Day Off',
    'Injury',
    'Sick',
    'Planned Day Off',
];

export const perceivedEfforts = [
    { value: 10, text: '10 Maximal' },
    { value: 9.5, text: '9.5' },
    { value: 9, text: '9.0' },
    { value: 8.5, text: '8.5' },
    { value: 8, text: '8.0 Very Hard' },
    { value: 7.5, text: '7.5' },
    { value: 7, text: '7.0 Hard' },
    { value: 6.5, text: '6.5' },
    { value: 6, text: '6.0 Slightly Hard' },
    { value: 5.5, text: '5.5' },
    { value: 5, text: '5.0 Moderate' },
    { value: 4.5, text: '4.5' },
    { value: 4, text: '4.0' },
    { value: 3.5, text: '3.5' },
    { value: 3, text: '3.0 Easy' },
    { value: 2.5, text: '2.5' },
    { value: 2, text: '2.0' },
    { value: 1.5, text: '1.5' },
    { value: 1, text: '1.0 Very Easy' },
    { value: 0.5, text: '0.5' },
    { value: 0, text: '0.0 No Exertion' },
];

export const FULL_MARATHON_DISTANCE = 26.2;
export const HALF_MARATHON_DISTANCE = 13.1;
export const TEN_K_DISTANCE = 6.2;

export const weights = [
    '75', '80', '85', '90', '95', '100', '105',
    '110', '115', '120', '125', '130', '135',
    '140', '145', '150', '155', '160', '165',
    '170', '175', '180', '185', '190', '195',
    '200', '205', '210', '215', '220', '225',
    '230', '235', '240', '245', '250', '255',
    '260', '265', '270', '275', '280', '285',
    '290', '295',
];

export const heights = [
    '48', '49', '50', '51', '52', '53', '54',
    '55', '56', '57', '58', '59', '60', '61',
    '62', '63', '64', '65', '66', '67', '68',
    '69', '70', '71', '72', '73', '74', '75',
    '76', '77', '78', '79', '80', '81', '82',
    '83', '84',
];

export const runDistances = {
    5000: '5K',
    5633: '3.5 miles',
    6000: '6000m',
    6437: '4 miles',
    8000: '8K',
    8047: '5 miles',
    8369: '5.2 miles',
    10000: '10K',
    11265: '7 miles',
    12000: '12000m',
    13036: '8.1 miles',
    14484: '9 miles',
    15000: '15K',
    16093: '10 miles',
    20000: '20K',
    25000: '25K',
    21098: 'Half Marathon',
    42195: 'Marathon',
};

export const runDistancesInPlan = {
    5000: '5K',
    5633: '3.5 miles',
    6000: '6000m',
    6437: '4 miles',
    8000: '8K',
    8047: '5 miles',
    8369: '5.2 miles',
    10000: '10K',
    11265: '7 miles',
    12000: '12000m',
    13036: '8.1 miles',
    14484: '9 miles',
    15000: '15K',
    16093: '10 miles',
    20000: '20K',
    25000: '25K',
    21098: 'Half Marathon',
};

export const runDistancesInPlanKm = {
    5: '5K',
    5.6: '3.5 miles',
    6: '6000m',
    6.4: '4 miles',
    8: '8K',
    8.05: '5 miles',
    8.4: '5.2 miles',
    10: '10K',
    11.3: '7 miles',
    12: '12000m',
    13: '8.1 miles',
    14.5: '9 miles',
    15: '15K',
    16.1: '10 miles',
    20: '20K',
    25: '25K',
    21.1: 'Half Marathon',
};

export const runDistancesInPlanMi = {
    3.1: '5K',
    3.5: '3.5 miles',
    3.7: '6000m',
    4: '4 miles',
    4.97: '8K',
    5: '5 miles',
    5.2: '5.2 miles',
    6.2: '10K',
    7: '7 miles',
    7.5: '12000m',
    8.1: '8.1 miles',
    9: '9 miles',
    9.3: '15K',
    10: '10 miles',
    12.4: '20K',
    15.5: '25K',
    13.1: 'Half Marathon',
};

export const buildRunDistances = (units, isGoal = false) => {
    const standardDistances = units === 'Metric' ? runDistancesInPlanKm : runDistancesInPlanMi;
    if (isGoal) {
        const mara = { 26.2: 'Marathon' };
        Object.assign(standardDistances, mara);
    }
    return standardDistances;
};

export const findClosestDistance = (logged, distances) => {
    const closest = Object.keys(distances).reduce((prev, curr) => (
        Math.abs(curr - logged) < Math.abs(prev - logged) ? curr : prev
    ));
    return closest;
};

export const motivations = {
    1: 'Weight control',
    2: 'Maintain health and fitness',
    3: 'Charity or fundraising team',
    4: 'Personal achievement',
    5: 'Social engagement',
};

export const terrains = {
    0: 'Not sure',
    1: 'Flat',
    2: 'Rolling Hills',
    3: 'Hilly',
};

export const runPaces = [
    { val: 6.0, miles: '6:00', km: '3:44' },
    { val: 6.08, miles: '6:05', km: '3:47' },
    { val: 6.17, miles: '6:10', km: '3:50' },
    { val: 6.25, miles: '6:15', km: '3:53' },
    { val: 6.34, miles: '6:20', km: '3:56' },
    { val: 6.42, miles: '6:25', km: '3:59' },
    { val: 6.5, miles: '6:30', km: '4:02' },
    { val: 6.58, miles: '6:35', km: '4:04' },
    { val: 6.66, miles: '6:40', km: '4:09' },
    { val: 6.74, miles: '6:45', km: '4:12' },
    { val: 6.82, miles: '6:50', km: '4:15' },
    { val: 6.91, miles: '6:55', km: '4:18' },
    { val: 7.0, miles: '7:00', km: '4:21' },
    { val: 7.08, miles: '7:05', km: '4:24' },
    { val: 7.17, miles: '7:10', km: '4:27' },
    { val: 7.25, miles: '7:15', km: '4:30' },
    { val: 7.34, miles: '7:20', km: '4:33' },
    { val: 7.42, miles: '7:25', km: '4:36' },
    { val: 7.5, miles: '7:30', km: '4:40' },
    { val: 7.58, miles: '7:35', km: '4:43' },
    { val: 7.66, miles: '7:40', km: '4:46' },
    { val: 7.74, miles: '7:45', km: '4:43' },
    { val: 7.82, miles: '7:50', km: '4:52' },
    { val: 7.9, miles: '7:55', km: '4:55' },
    { val: 8.0, miles: '8:00', km: '4:58' },
    { val: 8.08, miles: '8:05', km: '5:01' },
    { val: 8.17, miles: '8:10', km: '5:05' },
    { val: 8.25, miles: '8:15', km: '5:08' },
    { val: 8.34, miles: '8:20', km: '5:11' },
    { val: 8.42, miles: '8:25', km: '5:14' },
    { val: 8.5, miles: '8:30', km: '5:17' },
    { val: 8.58, miles: '8:35', km: '5:20' },
    { val: 8.66, miles: '8:40', km: '5:23' },
    { val: 8.74, miles: '8:45', km: '5:26' },
    { val: 8.82, miles: '8:50', km: '5:29' },
    { val: 8.91, miles: '8:55', km: '5:33' },
    { val: 9.0, miles: '9:00', km: '5:36' },
    { val: 9.08, miles: '9:05', km: '5:39' },
    { val: 9.16, miles: '9:10', km: '5:42' },
    { val: 9.25, miles: '9:15', km: '5:45' },
    { val: 9.34, miles: '9:20', km: '5:48' },
    { val: 9.42, miles: '9:25', km: '5:51' },
    { val: 9.5, miles: '9:30', km: '5:54' },
    { val: 9.58, miles: '9:35', km: '5:57' },
    { val: 9.66, miles: '9:40', km: '6:00' },
    { val: 9.74, miles: '9:45', km: '6:04' },
    { val: 9.82, miles: '9:50', km: '6:07' },
    { val: 9.91, miles: '9:55', km: '6:10' },
    { val: 10.00, miles: '10:00', km: '6:13' },
    { val: 10.08, miles: '10:05', km: '6:16' },
    { val: 10.16, miles: '10:10', km: '6:19' },
    { val: 10.25, miles: '10:15', km: '6:22' },
    { val: 10.34, miles: '10:20', km: '6:25' },
    { val: 10.42, miles: '10:25', km: '6:28' },
    { val: 10.5, miles: '10:30', km: '6:32' },
    { val: 10.58, miles: '10:35', km: '6:35' },
    { val: 10.67, miles: '10:40', km: '6:38' },
    { val: 10.75, miles: '10:45', km: '6:41' },
    { val: 10.82, miles: '10:50', km: '6:44' },
    { val: 10.91, miles: '10:55', km: '6:47' },
    { val: 11.00, miles: '11:00', km: '6:50' },
    { val: 11.08, miles: '11:05', km: '6:53' },
    { val: 11.16, miles: '11:10', km: '6:56' },
    { val: 11.25, miles: '11:15', km: '6:59' },
    { val: 11.34, miles: '11:20', km: '7:03' },
    { val: 11.42, miles: '11:25', km: '7:06' },
    { val: 11.5, miles: '11:30', km: '7:09' },
    { val: 11.58, miles: '11:35', km: '7:12' },
    { val: 11.67, miles: '11:40', km: '7:15' },
    { val: 11.75, miles: '11:45', km: '7:18' },
    { val: 11.82, miles: '11:50', km: '7:21' },
    { val: 11.91, miles: '11:55', km: '7:24' },
    { val: 12.00, miles: '12:00', km: '7:27' },
    { val: 12.08, miles: '12:05', km: '7:30' },
    { val: 12.16, miles: '12:10', km: '7:34' },
    { val: 12.25, miles: '12:15', km: '7:37' },
    { val: 12.34, miles: '12:20', km: '7:40' },
    { val: 12.42, miles: '12:25', km: '7:43' },
    { val: 12.5, miles: '12:30', km: '7:46' },
    { val: 12.58, miles: '12:35', km: '7:49' },
    { val: 12.67, miles: '12:40', km: '7:52' },
    { val: 12.75, miles: '12:45', km: '7:55' },
    { val: 12.82, miles: '12:50', km: '7:59' },
    { val: 12.91, miles: '12:55', km: '8:01' },
    { val: 13.00, miles: '13:00', km: '8:05' },
    { val: 13.08, miles: '13:05', km: '8:08' },
    { val: 13.16, miles: '13:10', km: '8:11' },
    { val: 13.25, miles: '13:15', km: '8:14' },
    { val: 13.34, miles: '13:20', km: '8:17' },
    { val: 13.42, miles: '13:25', km: '8:20' },
    { val: 13.5, miles: '13:30', km: '8:23' },
    { val: 13.58, miles: '13:35', km: '8:27' },
    { val: 13.67, miles: '13:40', km: '8:30' },
    { val: 13.75, miles: '13:45', km: '8:33' },
    { val: 13.83, miles: '13:50', km: '8:36' },
    { val: 13.91, miles: '13:55', km: '8:39' },
    { val: 14.00, miles: '14:00', km: '8:42' },
];

export const injuries = {
    0: 'No, completely healthy',
    1: 'Minor, only missed a few days of running',
    2: 'Major, unable to run for more than a week',
};

let site = 'https://runtrix.herokuapp.com';
if (process.env.NODE_ENV === 'development') {
    site = 'http://localhost:3000';
}

export const contactSubjects = [
    'I want to offer RUNtrix at my next event.',
    'I have an issue with my RUNtrix account.',
    'I\'d like to partner with RUNtrix',
    'I have a question about RUNtrix Training Plans.',
    'Other',
];

export const contactUsSubjects = [
    'Training Plan Question',
    'Interested in Membership Plan Beta Testing',
    'Injury/Sickness Question',
    'In-Plan Race Question',
    'Technical Assistance',
    'Billing/Payment Issue',
    'Other',
];

export const gpsWatches = [
    {
        value: 'garmin',
        text: 'Garmin',
    },
    {
        value: 'apple',
        text: 'Apple Watch',
    },
    {
        value: 'suunto',
        text: 'Suunto',
    },
    {
        value: 'polar',
        text: 'Polar',
    },
    {
        value: 'fitbit',
        text: 'FitBit',
    },
    {
        value: 'tomtom',
        text: 'Tomtom',
    },
    {
        value: 'timex',
        text: 'Timex',
    },
    {
        value: 'other',
        text: 'Other',
    },
];

export const statesList = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};

export const siteRoot = site;

export const requiredMsg = 'Required Field';

export const paceError = 'Please check your time and distance because your pace is outside of the allowable range';

// export const stripeKey = 'pk_test_rxvFsvdXzGRr2m7LRtJUyldU';
export const stripeKey = 'pk_live_aJUWKZO86XJtSeQuum3bCCoM';

export const googleAnalyticsKey = 'UA-100372944-1';

export const generatePdfURL = `${process.env.RTAPI_URL}/API_print_week.php`;

export const printFullDataUrl = `${process.env.RTAPI_URL}/API_print_log.php`;

export const apiKey = '1982-3256-8901-0012';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/